const NS = 'ProgrammesPage';
const CLS = 'programmesPage';
const CLS_HIDE = 'd-none';
const CLS_MB_ACTIVE = 'is-mbActive';

import Handlebars from 'handlebars';
import { ProgramsWideCarouselBlock } from '../../../blocks/programsWideCarouselBlock/js/programsWideCarouselBlock';
import { CoursesCarouselBlock } from '../../../blocks/coursesCarouselBlock/js/coursesCarouselBlock';
import { ProgressRadialCheckWidget } from '../../../widgets/progressRadialCheckWidget/js/progressRadialCheckWidget';
import { SearchFilterCheckboxWidget } from '../../../widgets/searchFilterCheckboxWidget/js/searchFilterCheckboxWidget';
import { utils } from '../../../../global/js/utils';
import { mediaQuery } from '../../../../global/js/wlc/mediaQuery';
import { spinnerService } from '../../../../global/js/wlc/spinnerService';
import { ifCond, placeholderImage } from '../../../../../handlebarsHelpers';

export class ProgrammesPage {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$topbar = this.$element.find(`.searchFilterTopBarWidget`);
		this.$fltBtnMb = this.$element.find(`.searchFilterTopBarWidget-fltBtnMb`);
		this.$filterTagBtns = this.$element.find(`.searchFilterTopBarWidget-tag-btn`);
		this.$fltBtnCloseMb = this.$element.find(`.searchFilterTopBarWidget-fltBtnCloseMb`);

		this.$sidebar = this.$element.find(`.searchFilterSidebarWidget`);
		this.$filterTitlesList = this.$element.find(`.searchFilterSidebarWidget-filter-titles-btn`);
		this.$fltApplyBtnMb = this.$sidebar.find(`.searchFilterSidebarWidget-fltApplyBtnMb`);
		this.$fltResetBtnMb = this.$sidebar.find(`.searchFilterSidebarWidget-fltResetBtnMb`);
		this.$filterItemsList = this.$element.find(`.searchFilterSidebarWidget-filter-item`);

		this.$resultsHtml = this.$element.find(`.${CLS}-results`);
		this.$noResultsHtml = this.$element.find(`.${CLS}-noResults`);
		
		this.spinnerService = spinnerService;
		this.siteId = this.$element.data('siteId');
		this.getApi = this.$element.data('getItemsApi');
		this.getProgramDetailsApi = this.$element.data('getProgramDetailsApi');

		this.params = {
			siteId: this.siteId
		};
		
		this.setProgramsWideCarouselBlockTemplate();
		this.setCoursesCarouselBlockTemplate();
		this.initCheckbox();
		this.setCheckboxParam();
		this.handleFilterBtnMb();
		this.handleFilterTitleTagBtns();
		this.getItems();
	}

	// Programs Wide Carousel Template
	setProgramsWideCarouselBlockTemplate() {
		let programsWideCarouselBlockPartial = require('../../../blocks/programsWideCarouselBlock/tmpl/programsWideCarouselBlock.hbs');
		let programCardBlockPartial = require('../../../blocks/programCardBlock/tmpl/programCardBlock.hbs');
		let progressRadialCheckWidgetPartial = require('../../../widgets/progressRadialCheckWidget/tmpl/progressRadialCheckWidget.hbs');

		Handlebars.registerPartial('programsWideCarouselBlock', programsWideCarouselBlockPartial);
		Handlebars.registerPartial('programCardBlock', programCardBlockPartial);
		Handlebars.registerPartial('progressRadialCheckWidget', progressRadialCheckWidgetPartial);

		let template = `
			{{> programsWideCarouselBlock 
				animateScrollReveal=false 
				api="${this.getProgramDetailsApi}"
			}}
		`;
		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		this.programsWideCarouselBlockTemplate = Handlebars.template(precompiled);

		Handlebars.registerHelper('ifCond', ifCond);
		Handlebars.registerHelper('placeholderImage', placeholderImage);
	}

	// Courses Carousel Template
	setCoursesCarouselBlockTemplate() {
		let coursesCarouselBlockPartial = require('../../../blocks/coursesCarouselBlock/tmpl/coursesCarouselBlock.hbs');
		let coursesCardBlockPartial = require('../../../blocks/coursesCardBlock/tmpl/coursesCardBlock.hbs');
		let progressRadialCheckWidgetPartial = require('../../../widgets/progressRadialCheckWidget/tmpl/progressRadialCheckWidget.hbs');

		Handlebars.registerPartial('coursesCarouselBlock', coursesCarouselBlockPartial);
		Handlebars.registerPartial('coursesCardBlock', coursesCardBlockPartial);
		Handlebars.registerPartial('progressRadialCheckWidget', progressRadialCheckWidgetPartial);

		let template = `
			{{> coursesCarouselBlock
				animateScrollReveal=false 
			}}
		`;
		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		this.coursesCarouselBlockTemplate = Handlebars.template(precompiled);

		Handlebars.registerHelper('ifCond', ifCond);
		Handlebars.registerHelper('placeholderImage', placeholderImage);
	}

	// Get items (reload content)
	getItems() {
		// URL Params
		let url = this.getApi;
		if(!_.isEmpty(this.params)) {
			url += `?${$.param(this.params)}`;
		}

		// Display spinner
		this.spinnerService.appendTo();
		this.updateUrl();

		// Fetch data
		$.ajax({
			type: 'GET',
			url: url,
			success: (data) => {
				let items = data.results;

				// Empty existing html
				this.$resultsHtml.empty();
				this.$noResultsHtml.hide();

				// Loop over results
				if(items.length > 0) {
					items.forEach((item) => {
						if(item.blk === 'programsWideCarouselBlock') {
							let itemMarkup = this.programsWideCarouselBlockTemplate(item);
							this.$resultsHtml.append(`${itemMarkup}`);
						}
						if(item.blk === 'coursesCarouselBlock') {
							let itemMarkup = this.coursesCarouselBlockTemplate(item);
							this.$resultsHtml.append(`${itemMarkup}`);
						}
					});

					// Init ProgramsWideCarouselBlock JS
					this.$resultsHtml.find(`[data-blk="ProgramsWideCarouselBlock"]`).each((_index, element) => {
						if(element) {
							new ProgramsWideCarouselBlock(element);
						}
					});

					// Init CoursesCarouselBlock JS
					this.$resultsHtml.find(`[data-blk="CoursesCarouselBlock"]`).each((_index, element) => {
						if(element) {
							new CoursesCarouselBlock(element);
						}
					});

					// Init ProgressRadialCheckWidget JS
					this.$resultsHtml.find(`[data-wg="ProgressRadialCheckWidget"]`).each((_index, element) => {
						if(element) {
							new ProgressRadialCheckWidget(element);
						}
					});
				}
				else {
					// No results
					this.$noResultsHtml.show();
				}

				// Remove spinner
				this.spinnerService.removeFrom();
			}
		});
	}

	// Update url after filters change
	updateUrl() {
		let uri = document.location.pathname;

		Object.keys(this.params).forEach((key, index) => {
			uri = utils.updateUrlParameter(uri, key, this.params[key]);
		});

		// update url without reload
		window.history.pushState('', '', uri);
	}

	// Sidebar Checkboxes init
	initCheckbox() {
		let $checkboxWg = this.$sidebar.find('.searchFilterCheckboxWidget');

		$checkboxWg.each((i, obj) => {
			new SearchFilterCheckboxWidget(obj, _.debounce((cbVal) => {
				this.setCheckboxParam();

				if(!mediaQuery.breakpointMaxWidth(mediaQuery.BREAKPOINTS.MD)) {
					this.getItems();
				}
			}, 500));
		});
	}

	// Sidebar Checkboxes listener
	setCheckboxParam() {
		const $checkboxWg = this.$sidebar.find('.searchFilterCheckboxWidget');
		const allCbVal = [];

		// Refresh Filter Tag Buttons
		this.$filterTagBtns.removeClass(CLS_MB_ACTIVE);

		$checkboxWg.each((i, obj) => {
			const $el = $(obj);
			const cbVal = [];
			const elFilterKey = $el.data('filter-key');

			$el.find(`input[type="checkbox"]:checked`).each((i, ckbx) => {
				const cbValue = $(ckbx).val().toString();
				cbVal.push(cbValue);

				// Refresh Filter Tag Buttons
				_.each(this.$filterTagBtns, (obj) => {
					const $obj = $(obj);
					const filterKeyItem = $obj.data('filter-key').toString();
					const valueItem = $obj.data('value').toString();
					if(filterKeyItem === elFilterKey && valueItem === cbValue) {
						$obj.addClass(CLS_MB_ACTIVE);
					}
				});
			});

			allCbVal.push({
				name: elFilterKey,
				value: cbVal
			});
		});

		_.each(allCbVal, (obj, i) => {
			if(obj.value.length === 0) {
				delete this.params[obj.name];
			}
			else {
				this.params[obj.name] = obj.value.join(',');
			}
		});
	}

	// Filters toggle button
	handleFilterBtnMb() {
		this.$fltBtnMb.on('click', () => {
			if(this.$sidebar.hasClass(CLS_MB_ACTIVE)) {
				this.$fltBtnMb.removeClass(CLS_MB_ACTIVE);
				this.$sidebar.removeClass(CLS_MB_ACTIVE);
				this.$fltBtnCloseMb.removeClass(CLS_MB_ACTIVE);
			}
			else {
				this.$fltBtnMb.addClass(CLS_MB_ACTIVE);
				this.$sidebar.addClass(CLS_MB_ACTIVE);
				this.$fltBtnCloseMb.addClass(CLS_MB_ACTIVE);
			}
		});

		this.$fltBtnCloseMb.on('click', () => {1
			this.$fltBtnMb.removeClass(CLS_MB_ACTIVE);
			this.$sidebar.removeClass(CLS_MB_ACTIVE);
			this.$fltBtnCloseMb.removeClass(CLS_MB_ACTIVE);
		});

		this.$fltApplyBtnMb.on('click', () => {
			this.$fltBtnMb.removeClass(CLS_MB_ACTIVE);
			this.$sidebar.removeClass(CLS_MB_ACTIVE);
			this.$fltBtnCloseMb.removeClass(CLS_MB_ACTIVE);
			this.getItems();
		});

		this.$fltResetBtnMb.on('click', () => {
			this.resetCheckbox();
			this.getItems();
		});
	}

	// Sidebar filter titles (hover, click)
	handleFilterTitleTagBtns() {
		// New Filter Title Menu Buttons
		this.$filterTitlesList.on('click mouseover', (event) => {
			let $element = $(event.currentTarget);
			let filterKey = $element.data('filter-key');

			this.$filterTitlesList.removeClass(CLS_MB_ACTIVE);
			$element.addClass(CLS_MB_ACTIVE);

			this.$filterItemsList.removeClass(CLS_MB_ACTIVE);
			_.each(this.$filterItemsList, (obj) => {
				let $obj = $(obj);
				let filterKeyItem = $obj.data('filter-key');
				if(filterKeyItem === filterKey) {
					$obj.addClass(CLS_MB_ACTIVE);
				}
			});
		});

		// New Filter Tag Buttons
		this.$filterTagBtns.on('click', (event) => {
			let $element = $(event.currentTarget);
			let filterKey = $element.data('filter-key');
			let value = $element.data('value');
			let $checkboxWg = this.$sidebar.find('.searchFilterCheckboxWidget');

			$checkboxWg.each((i, obj) => {
				let $el = $(obj);

				if($el.data('filter-key') === filterKey) {
					$('input[type=checkbox][value="'+value+'"]', $el).prop('checked', false).trigger('change');
					$element.removeClass(CLS_MB_ACTIVE);
				}
			});
		});
	}

	// Sidebar Checkboxes reset
	resetCheckbox() {
		let $checkboxWg = this.$sidebar.find('.searchFilterCheckboxWidget');

		_.each($checkboxWg, (obj) => {
			let $obj = $(obj);
			let filterKey = $obj.data('filter-key');

			delete this.params[filterKey];
			$obj.find('input[type="checkbox"]').prop('checked', false);
		});

		// Refresh Filter Tag Buttons
		this.$filterTagBtns.removeClass(CLS_MB_ACTIVE);
	}
}
